import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SiteHeader, SiteFooter } from "@/components/Layout";
import AskBar from "@/components/AskBar";
import { useI18n } from "@/i18n";

export default function Ask() {
  const { t } = useI18n();
  const [answers, setAnswers] = useState([]);
  const [subOpen, setSubOpen] = useState(false);
  const [subEmail, setSubEmail] = useState("");
  const [subHp, setSubHp] = useState(""); // honeypot
  const [subBusy, setSubBusy] = useState(false);
  const [subDone, setSubDone] = useState(false);
  const [subError, setSubError] = useState("");

  useEffect(() => {
    document.title = "Ask — San Juanillo Rising";
    api.get("/questions/answered").then((r) => setAnswers(r.data)).catch(() => setAnswers([]));
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!subEmail.trim() || subBusy) return;
    setSubBusy(true);
    setSubError("");
    try {
      await api.post("/subscribers", { email: subEmail.trim(), website: subHp });
      setSubDone(true);
      setSubOpen(false);
    } catch (err) {
      setSubError(err?.response?.data?.detail || t("errGeneric"));
    } finally {
      setSubBusy(false);
    }
  };

  return (
    <div className="dd-root" data-testid="ask-page">
      <SiteHeader />
      <main className="ask-page">
        <div className="dd-wrap">
          <h1 className="ask-page-title" data-testid="ask-page-title">{t("askPlaceholder")}</h1>
          <p className="ask-page-sub">
            {t("askPageSubPre")}
            <button type="button" className="ask-sub-link" onClick={() => setSubOpen((o) => !o)} data-testid="ask-subscribe-link">
              {t("askPageSubLink")}
            </button>
            {t("askPageSubPost")}
          </p>
          {subOpen ? (
            <form className="ask-subscribe-box" onSubmit={subscribe} data-testid="subscribe-box">
              <input
                className="submit-input"
                type="email"
                value={subEmail}
                onChange={(e) => setSubEmail(e.target.value)}
                placeholder={t("subscribePh")}
                data-testid="subscribe-email-input"
              />
              <input type="text" className="ask-hp" value={subHp} onChange={(e) => setSubHp(e.target.value)} tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <button type="submit" className="ask-submit ask-submit-wide" disabled={subBusy || !subEmail.trim()} data-testid="subscribe-submit">
                {subBusy ? "…" : t("subscribeBtn")}
              </button>
            </form>
          ) : null}
          {subError ? <div className="ask-error ask-sub-error" data-testid="subscribe-error">{subError}</div> : null}
          {subDone ? <div className="ask-notice ask-sub-thanks" data-testid="subscribe-thanks">{t("subscribeThanks")}</div> : null}
          <AskBar prominent />

          <section className="ask-feed" data-testid="answers-feed">
            <h2 className="ask-feed-title">{t("answersTitle")}</h2>
            {answers.length === 0 ? (
              <p className="ask-feed-empty" data-testid="answers-empty">{t("answersEmpty")}</p>
            ) : (
              answers.map((a, i) => (
                <div className="ask-qa" key={a.id} data-testid={`answer-row-${i}`}>
                  <div className="ask-qa-q">{a.question}</div>
                  <div className="ask-qa-a">{a.answer}</div>
                </div>
              ))
            )}
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
